export default "__VITE_ASSET__BQfIj4gT__"